module.exports = __webpack_public_path__ + "img/tagimg.1a8ddd2f.png";